import { render, staticRenderFns } from "./FileVisu.vue?vue&type=template&id=3ab82475&lang=pug&"
import script from "./FileVisu.vue?vue&type=script&lang=js&"
export * from "./FileVisu.vue?vue&type=script&lang=js&"
import style0 from "./FileVisu.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ab82475')) {
      api.createRecord('3ab82475', component.options)
    } else {
      api.reload('3ab82475', component.options)
    }
    module.hot.accept("./FileVisu.vue?vue&type=template&id=3ab82475&lang=pug&", function () {
      api.rerender('3ab82475', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/library/FileVisu.vue"
export default component.exports